import React from 'react';

export interface IProps {
  fillColor?: string;
  strokeColor?: string;
}

const MonitorIcon:React.FC<IProps> = (props) => {
  return (
    <svg width="34" height="36" viewBox="0 0 34 36" fill={props.fillColor ?? "none"} xmlns="http://www.w3.org/2000/svg">
    <path d="M30.8553 0.8H3.14468C1.80156 0.8 0.8 2.14086 0.8 3.71139V26.2203C0.8 27.7908 1.80156 29.1316 3.14468 29.1316H13.566V33.0785H12.3702C11.8441 33.0785 11.4894 33.6016 11.4894 34.1392C11.4894 34.6769 11.8441 35.2 12.3702 35.2H22.2766C22.8027 35.2 23.1574 34.6769 23.1574 34.1392C23.1574 33.6016 22.8027 33.0785 22.2766 33.0785H20.7745V29.1316H30.8553C32.1984 29.1316 33.2 27.7908 33.2 26.2203V3.71139C33.2 2.14086 32.1984 0.8 30.8553 0.8ZM3.14468 2.92152H30.8553C31.1462 2.92152 31.4383 3.2161 31.4383 3.71139V21.3722H2.5617V3.71139C2.5617 3.2161 2.85376 2.92152 3.14468 2.92152ZM18.9787 33.0785H15.3277V29.1316H18.9787V33.0785ZM30.8553 27.0101H3.14468C2.85376 27.0101 2.5617 26.7155 2.5617 26.2203V23.4937H31.4383V26.2203C31.4383 26.7155 31.1462 27.0101 30.8553 27.0101Z" fill={props.strokeColor ?? "#112240"} stroke={props.strokeColor ?? "#112240"} stroke-width="0.4"/>
    </svg>
  )
}

export default MonitorIcon;